module.exports = __webpack_public_path__ + "static/media/half.93ec9275.svg";